export const GET_VPN_STATUS_REQUEST = 'GET_VPN_STATUS_REQUEST';
export const GET_VPN_STATUS_SUCCESS = 'GET_VPN_STATUS_SUCCESS';
export const GET_VPN_STATUS_FAILURE = 'GET_VPN_STATUS_FAILURE';
export const ACTIVATE_VPN_REQUEST = 'ACTIVATE_VPN_REQUEST';
export const ACTIVATE_VPN_SUCCESS = 'ACTIVATE_VPN_SUCCESS';
export const ACTIVATE_VPN_FAILURE = 'ACTIVATE_VPN_FAILURE';
export const SET_VPN_STATUS = 'SET_VPN_STATUS';
